import React, { useState, Fragment, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import classes from './NavContainer.module.css';
import logo from '../../../img/gritr_logo.png';
import { getIcon, startLinks } from './NavContainer.service';
import navIconDown from '../../../img/nav_icon_down.png';
import navIconRight from '../../../img/nav_icon_right.png';

// Icons
import { ReactComponent as UserIcon } from '../../../img/user_icon.svg';
import {
  GrFormClose,
  GrMenu,
  GrFormNext,
  GrFormPrevious,
} from 'react-icons/gr';
import { FiLogOut } from 'react-icons/fi';
import { INavUrl, INavOpenList, INavParams } from '../../../types/layout';

const NavContainer: React.FC<INavParams> = ({
  name,
  avatarPath,
  exit,
  leftData,
  role,
}) => {
  const location = useLocation();

  const [isOpen, setOpen] = useState(false);
  const [lists, openCloseList] = useState<INavOpenList[]>([]);
  const [links, setLink] = useState<INavUrl[]>([]);

  useEffect(() => {
    openCloseList(
      leftData
        .filter((data) => data.type === 'list')
        .map((data) => ({
          icon: data.icon ? data.icon : '',
          isOpen: data.list
            ? data.list.some((l) => l.url === location.pathname)
            : false,
        }))
    );
    setLink(startLinks(leftData, String(location.pathname)));
  }, [leftData, location.pathname]);

  const onMouseOver = (e: React.MouseEvent<HTMLDivElement>) => {
    if (e.currentTarget.contains(e.relatedTarget as HTMLDivElement)) return;
    if (window.innerWidth > 1024) {
      setOpen(true);
    }
  };

  const onMouseOut = (e: React.MouseEvent<HTMLDivElement>) => {
    if (e.currentTarget.contains(e.relatedTarget as HTMLDivElement)) return;
    if (window.innerWidth > 1024) {
      setOpen(false);
    }
  };

  const showLeftMenu = (e: React.MouseEvent) => {
    setOpen(!isOpen);
  };

  const changeList = (event: React.MouseEvent) => {
    const icon = event.currentTarget.getAttribute('data-icon');
    openCloseList(
      lists.map((list) => {
        if (list.icon === icon) {
          list.isOpen = !list.isOpen;
        } else {
          list.isOpen = false;
        }
        return list;
      })
    );
  };

  const checkAccess = (access: string[] | undefined) => {
    if (!access) return true;
    return access.includes(role);
  };

  return (
    <div className={classes.navBox}>
      <div
        className={`${isOpen ? classes.navLeftFull : classes.navLeft}`}
        onMouseOver={onMouseOver}
        onMouseOut={onMouseOut}
      >
        <div className={classes.navLeftClose}>
          <GrFormClose
            className={classes.navLeftCloseIcon}
            onClick={showLeftMenu}
          />
        </div>
        <div className={classes.navLeftArrow}>
          {isOpen ? (
            <GrFormPrevious
              className={classes.navLeftCloseIcon}
              onClick={showLeftMenu}
            />
          ) : (
            <GrFormNext
              className={classes.navLeftCloseIcon}
              onClick={showLeftMenu}
            />
          )}
        </div>
        <div className={isOpen ? classes.navLeftBodyFull : classes.navLeftBody}>
          {leftData.map((data, i: number) => {
            if (!checkAccess(data.access)) return null;
            if (data.type === 'list') {
              return (
                <div
                  className={classes.navLeftOptionList}
                  key={`leftdata-${i}`}
                >
                  <div
                    className={`${classes.navLeftOption} ${classes.navLeftList}`}
                    onClick={changeList}
                    data-icon={data.icon}
                  >
                    {getIcon(data.icon)}
                    {data.name}
                    <div className={classes.navIconImageBox}>
                      {lists.some(
                        (list: any) => list.icon === data.icon && list.isOpen
                      ) ? (
                        <img
                          src={navIconDown}
                          alt='navIconDown'
                          className={classes.navIconImage}
                        />
                      ) : (
                        <img
                          src={navIconRight}
                          alt='navIconRight'
                          className={classes.navIconImage}
                        />
                      )}
                    </div>
                  </div>
                  <ul
                    className={
                      lists.some(
                        (list: any) => list.icon === data.icon && list.isOpen
                      )
                        ? ''
                        : classes.navList
                    }
                  >
                    {data.list?.map((row: any, j: number) => {
                      return (
                        <Fragment key={`leftdata-row-${j}`}>
                          <li className={classes.navSublist}>
                            <Link
                              className={`${classes.navLeftOption} ${
                                classes.navLeftSublistOption
                              } ${
                                links.some(
                                  (url: any) =>
                                    url.path === row.url && url.isActive
                                )
                                  ? classes.navLeftListActive
                                  : ''
                              }`}
                              to={row.url}
                            >
                              {getIcon(row.icon)}
                              {row.name}
                            </Link>
                          </li>
                          {Array.isArray(data.list) &&
                          j !== data.list.length - 1 ? (
                            <li className={classes.navListDevider}></li>
                          ) : null}
                        </Fragment>
                      );
                    })}
                  </ul>
                </div>
              );
            } else if (data.type === 'devider') {
              return (
                <div className={classes.navDevider} key={`leftdata-${i}`}></div>
              );
            }

            return (
              <Link
                className={`${classes.navLeftOption} ${
                  links.some(
                    (url: any) => url.path === data.url && url.isActive
                  )
                    ? classes.navLeftListActive
                    : ''
                }`}
                to={data.url ? data.url : '/'}
                key={`leftdata-${i}`}
              >
                {getIcon(data.icon)}
                {data.name}
              </Link>
            );
          })}
        </div>
      </div>
      <div className={classes.navTop}>
        <div className={classes.navTopMobile}>
          <GrMenu className={classes.navTopIcon} onClick={showLeftMenu} />
        </div>
        <div className={classes.navUserBox}>
          <Link className={classes.navAvatarBox} to='/userinfo/'>
            {avatarPath ? (
              <img
                src={`/api/files/avatars/${avatarPath}`}
                alt='avatar'
                className={classes.navAvatar}
              />
            ) : (
              <UserIcon className={classes.navTopIconCustom} />
            )}
            <span className={classes.navUserName}>
              <span>Welcome,</span>
              <b>{name}</b>
            </span>
          </Link>
        </div>
        <div className={classes.navLogo}>
          <Link className={classes.blackLink} to='/dashboard/'>
            <img src={logo} alt='Logo' />
          </Link>
        </div>
        <div className={classes.navIconsMenu}>
          <Link className={classes.blackLink} to='/' onClick={exit}>
            <FiLogOut className={classes.navMiIcon} />
          </Link>
        </div>
      </div>
    </div>
  );
};

export default NavContainer;
